import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

export const Panel = ({ title, children, testId }) => (
  <Card className="bg-white border-slate-200 shadow-none" data-testid={testId}>
    <CardContent className="p-5">
      <h3 className="text-[11px] uppercase tracking-wider font-bold text-slate-500 mb-4">{title}</h3>
      {children}
    </CardContent>
  </Card>
);

export const BarRow = ({ label, count, pct, testId }) => (
  <div data-testid={testId}>
    <div className="flex items-baseline justify-between gap-3 text-sm">
      <span className="text-slate-700 truncate">{label}</span>
      <span className="font-bold text-slate-900 tabular-nums shrink-0">
        {count}{pct !== undefined && <span className="ml-1.5 text-xs font-semibold text-slate-400">{pct}%</span>}
      </span>
    </div>
    <div className="h-2 rounded-full bg-slate-100 mt-1.5 overflow-hidden">
      <div className="h-full rounded-full bg-[#00247D] transition-[width] duration-500" style={{ width: `${Math.min(100, pct || 0)}%` }} />
    </div>
  </div>
);

export const Big = ({ label, value, sub, tone = 'text-slate-900', testId }) => (
  <div>
    <div className="text-xs text-slate-500">{label}</div>
    <div className={`text-3xl font-black tabular-nums ${tone}`} data-testid={testId}>{value}</div>
    {sub && <div className="text-xs text-slate-500 mt-0.5">{sub}</div>}
  </div>
);
